export default __webpack_public_path__ + "static/media/Affogato2.957b168a.jpg";